import React from "react";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import ChatBubble from "@/components/ChatBubble";

export default function Layout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen flex bg-slate-50">
      <Sidebar />
      <div className="flex-1 min-w-0 flex flex-col">
        <TopBar title={title} subtitle={subtitle} />
        <main className="flex-1 px-4 sm:px-6 lg:px-10 py-8 lg:py-10 max-w-[1400px] w-full mx-auto">
          {children}
        </main>
      </div>
      <ChatBubble />
    </div>
  );
}
